// src/components/index.js
export { default as AppHeader } from './AppHeader';
export { default as Sidebar } from './Sidebar';
export { default as AppContent } from './AppContent'; // Убедитесь, что путь правильный